import "../components/styles/style.css";

export function CircularProgress() {
  return <div className="circular-progress" />;
}
